// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class AsyncJobSummary {
  readonly id: string;
  readonly jobType: Enums.AsyncJobType;
  readonly status: Enums.AsyncJobStatus;
  readonly itemsTotal: number;
  readonly itemsProcessed: number;
  readonly itemsFailed: number;
  readonly errorMessage: string | null;
  readonly createdAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.jobType =
      data.jobType === undefined ? Enums.AsyncJobType.QuotePricingUpdate : data.jobType;
    this.status = data.status === undefined ? Enums.AsyncJobStatus.Pending : data.status;
    this.itemsTotal = data.itemsTotal === undefined ? 0 : data.itemsTotal;
    this.itemsProcessed = data.itemsProcessed === undefined ? 0 : data.itemsProcessed;
    this.itemsFailed = data.itemsFailed === undefined ? 0 : data.itemsFailed;
    this.errorMessage = data.errorMessage === undefined ? null : data.errorMessage;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
  }

  static zero(): AsyncJobSummary {
    const zeroValues: ExcludeMethodsDeep<AsyncJobSummary> = {
      id: NIL_UUID,
      jobType: Enums.AsyncJobType.QuotePricingUpdate,
      status: Enums.AsyncJobStatus.Pending,
      itemsTotal: 0,
      itemsProcessed: 0,
      itemsFailed: 0,
      errorMessage: null,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new AsyncJobSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AsyncJobSummaryWireFormat = {
  id: string;
  jobType: string;
  status: string;
  itemsTotal: number;
  itemsProcessed: number;
  itemsFailed: number;
  errorMessage: string | null;
  createdAt: string;
};

type NewAsyncJobSummaryProps = PartialDeep<AsyncJobSummary, { recurseIntoArrays: true }>;
export const NewAsyncJobSummary: (props: NewAsyncJobSummaryProps) => AsyncJobSummary = (props) =>
  new AsyncJobSummary(props);

type NewAsyncJobSummaryFromWireFormatProps = PartialDeep<
  AsyncJobSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAsyncJobSummaryFromWireFormat: (
  props: NewAsyncJobSummaryFromWireFormatProps,
) => AsyncJobSummary = (props) => new AsyncJobSummary(props);
